import { render, staticRenderFns } from "./EmulatorScopeSelector.vue?vue&type=template&id=7ef014ef&scoped=true"
import script from "./EmulatorScopeSelector.vue?vue&type=script&lang=js"
export * from "./EmulatorScopeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef014ef",
  null
  
)

export default component.exports